export default "__VITE_ASSET__5mL5jau3__"